import {
  ImmadiateDeliveryIcon,
  PartialPaymentIcon,
  DeprecationIcon,
  RateIcon,
  CashIcon,
  InstalmentIcon,
  InterestIcon,
  DelayIcon,
  DepletableIcon,
} from "assets/svg/campaigns";

import {
  ImmediateDeliveryIcon,
  PercentageIcon,
  ProjectTypeIcon,
  LocationIcon,
  GroundSurveyIcon,
  HousingTypeIcon,
  HousingCountIcon,
  LandAreaIcon,
  EarthquakeRegulationsIcon,
} from "assets/svg/project-detail";

const CampaignTypes = {
  DELAY: "DELAY",
  INSTALMENT: "INSTALMENT",
  DEPLETABLE: "DEPLETABLE",
  CASH: "CASH",
  INTEREST: "INTEREST",
  PARTIAL_PAYMENT: "PARTIAL_PAYMENT",
  RATE: "RATE",
  IMMEDIATE_DELIVERY: "IMMEDIATE_DELIVERY",
  DEPRECIATION: "DEPRECIATION",
};

const ProjectTypes = {
  OFFICE: "İş Yeri",
  HOUSING: "Konut",
  LAND: "Arsa",
  APARTMENT: "Daire",
  VILLA: "Villa",
  RESIDENTIAL: "Rezidans",
  HOUSING_PERMITTED_LAND: "Konut İmarlı",
  LAND_VILLA_PERMIT: "Villa İmarlı",
  LAND_COMMERCIAL_PERMIT: "Ticari İmarlı",
  LAND_TOURISM_PERMIT: "Turizm İmarlı",
  SPECIAL_USE: "Özel İmarlı",
  GARDEN: "Bağ & Bahçe",
  FIELD: "Tarla",
  STORE: "Dükkan & Mağaza",
  STORAGE: "Depo",
};

const ProjectCampaignIcons = {
  DELAY: <DelayIcon />,
  INSTALMENT: <InstalmentIcon />,
  DEPLETABLE: <DepletableIcon />,
  CASH: <CashIcon />,
  INTEREST: <InterestIcon />,
  PARTIAL_PAYMENT: <PartialPaymentIcon />,
  RATE: <RateIcon />,
  IMMEDIATE_DELIVERY: <ImmadiateDeliveryIcon />,
  DEPRECIATION: <DeprecationIcon />,
};

const ProjectFeatures = [
  { icon: LocationIcon, title: "Konum", key: "location" },
  { icon: ProjectTypeIcon, title: "Proje Tipi", key: "projectType" },
  { icon: ImmediateDeliveryIcon, title: "Teslim Tarihi", key: "deliveryDate" },
  { icon: HousingTypeIcon, title: "Konut Tipleri", key: "housingTypes" },
  { icon: HousingCountIcon, title: "Konut Sayısı", key: "housingCount" },
  { icon: LandAreaIcon, title: "Toplam Arsa Alanı", key: "landArea" },
  { icon: PercentageIcon, title: "Proje İnşaatı", key: "completionPercentage" },
  { icon: GroundSurveyIcon, title: "Zemin Etüdü", key: "groundSurvey" },
  { icon: EarthquakeRegulationsIcon, title: "Deprem Yönetmeliği", key: "earthquakeRegulations" },
  { icon: PercentageIcon, title: "Satış Yüzdesi", key: "salesPercentage" },
];

const FLOOR_TYPES = [
  { value: "-1", label: "Tek Kat" },
  { value: "13", label: "Yüksek giriş" },
  { value: "14", label: "Düz giriş" },
  { value: "15", label: "Yüksek bodrum" },
  { value: "16", label: "Yarı bodrum" },
  { value: "17", label: "Tam bodrum" },
  { value: "18", label: "Bahçe katı" },
  { value: "19", label: "Bahçe dubleks" },
  { value: "20", label: "Çatı Dubleks" },
  { value: "21", label: "Çatı Katı" },
  { value: "5", label: "Dubleks" },
  { value: "54", label: "Müstakil" },
  { value: "55", label: "Villa tipi" },
  { value: "56", label: "Kot 1" },
  { value: "57", label: "Kot 2" },
  { value: "58", label: "Kot 3" },
  { value: "59", label: "Asma Kat" },
  { value: "6", label: "İkiz Ev" },
  { value: "7", label: "Müstakil Ev" },
  { value: "8", label: "Tripleks" },
  { value: "9", label: "Fourleks" },
];

const getProjectCampaignTitle = ({ name, campaignTitle: title }) => {
  const titleMap = {
    [CampaignTypes.CASH]: `%${title} Peşin`,
    [CampaignTypes.INTEREST]: `%${title} Faiz`,
    [CampaignTypes.PARTIAL_PAYMENT]: `${title} Ara Ödemeli`,
    [CampaignTypes.RATE]: `${title} Oran`,
    [CampaignTypes.IMMEDIATE_DELIVERY]: "Hemen Teslim",
    [CampaignTypes.DEPRECIATION]: `${title} Yılda Amortisman`,
    [CampaignTypes.INSTALMENT]: `${title} Ay Taksit`,
    [CampaignTypes.DELAY]: `${title} Ay Vade`,
    [CampaignTypes.DEPLETABLE]: "Tükenmek Üzere",
  };

  return titleMap[name] || title;
};

const getProjectType = (type) => ProjectTypes[type] || null;

export { ProjectCampaignIcons, getProjectCampaignTitle, getProjectType, ProjectFeatures, FLOOR_TYPES };
